'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('@emotion/react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('../../../../../../_virtual/index.cjs');
var InternalButtonLink_web = require('../../internal/InternalButtonLink/InternalButtonLink.web.cjs');
require('react');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
require('../Typography/Typography.web.cjs');
require('../../internal/InternalToggle/InternalToggle.web.cjs');
var NoStyleButton_web_styles = require('./NoStyleButton.web.styles.cjs');

/**
 * A button component without default browser styles used as a trigger to perform a specific action
 *
 * {@link https://aviary.fullscript.io/latest/components/no-style-button-short-pressable/web-ee6D1N56 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/NoStyleButton/NoStyleButton.web.tsx | View in GitLab}
 *
 * @scope Core, Web (ShortPressable in Native)
 */ const NoStyleButton = ({ customCss, ...props })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(InternalButtonLink_web.InternalButtonLink, {
        css: [
            NoStyleButton_web_styles.disabled,
            customCss
        ],
        ...props
    });
};

exports.NoStyleButton = NoStyleButton;
//# sourceMappingURL=NoStyleButton.web.cjs.map
